<template>
  <div
    v-if="isVisible"
    class="bnr">
    <i class="bnr__close" @click="closeBanner">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
        <path d="M256-213.85 213.85-256l224-224-224-224L256-746.15l224 224 224-224L746.15-704l-224 224 224 224L704-213.85l-224-224-224 224Z"/>
      </svg>
    </i>
    <a href="/" target="_blank" rel="nofollow">
      <img src="/images/common/rokuya_bnr.webp" alt="当社系列旅館 網元の宿ろくや 公式Webサイト">
    </a>
  </div>
</template>

<style lang="scss" scoped>
.bnr{
  width: 18rem;
  right: 1.2rem;
  bottom: calc(var(--reservation-fix-area) + 1.2rem);
  position: fixed;
  z-index: 500;
  &__close{
    position: absolute;
    top: 0;
    right: 0;
    width: 2.4rem;
    height: 2.4rem;
    background: module.tone(module.$black, -2);
    border-radius: 50%;
    @include module.flex();
    align-items: center;
    justify-content: center;
    transform: translate(25%, -25%);
    cursor: pointer;
    z-index: 2;
    transition: transform 200ms module.$ease;
    &:hover{
      transform: translate(25%, -25%) scale(1.1);
      svg{
        transform: scale(.9);
      }
    }
    svg{
      width: 1.2rem;
      fill: module.$gray;
      transition: transform 200ms module.$ease;
    }
  }
  a{
    display: block;
    border-radius: .4rem;
    overflow: hidden;
    &:hover{
      background: module.$white;
      img{
        opacity: .96;
      }
    }
  }
  img{
    width: 100%;
  }
}
</style>

<script>
const STORAGE_KEY = 'rokuya_bnr_closed'
export default {
  data() {
    return {
      isVisible: false,
    }
  },

  mounted() {
    this.isVisible = localStorage.getItem(STORAGE_KEY) !== 'true'
  },

  methods: {
    closeBanner() {
      this.isVisible = false
      localStorage.setItem(STORAGE_KEY, 'true')
    },
  },
}
</script>